import React from 'react';

const ReportType = {
  HOUSEKEEPING: 'HOUSEKEEPING',
  INSPECTOR_PROPERTY_MANAGER: 'INSPECTOR_PROPERTY_MANAGER',
  WORK_ORDERS: 'WORK_ORDERS'
};

const ReportTypeSelector = ({ value, onChange }) => {
  const reportTypes = [
    { 
      value: ReportType.HOUSEKEEPING, 
      label: 'Housekeeping',
      description: 'Financial report with payout and billing tracking'
    },
    { 
      value: ReportType.INSPECTOR_PROPERTY_MANAGER, 
      label: 'Inspector & Property Manager',
      description: 'Job completion report (no financial tracking)'
    }
  ];

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Report Type
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-500 focus:ring-sky-500"
      >
        {reportTypes.map(type => (
          <option 
            key={type.value} 
            value={type.value} 
            disabled={type.disabled}
          >
            {type.label} {type.disabled ? '(Coming Soon)' : ''}
          </option>
        ))}
      </select>
      <p className="text-sm text-gray-500">
        {reportTypes.find(type => type.value === value)?.description}
      </p>
    </div>
  );
};

export { ReportType };
export default ReportTypeSelector;
